module.exports = __webpack_public_path__ + "img/cert-acrisure-safety.b7805862.png";